module.exports = __webpack_public_path__ + "static/media/CouplesIntake.a5764005.pdf";